export enum AttentionBoxType {
  PRIMARY = "primary",
  SUCCESS = "success",
  DANGER = "danger",
  DARK = "dark",
  WARNING = "warning"
}
